import $ from 'jquery';
const $burger_el = $("#burger-menu");
const $body_el = $("body");
const init_burger_menu = () => {
    $burger_el.on('click', () => {
        $body_el.toggleClass("mobile-nav-opened");
        $burger_el.trigger("mobile-nav-toggle");
    })
}

export {init_burger_menu};
